module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h0WOu"))).then(() => module.bundle.root('3a9aZ'));